import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        /* Novas variantes para o Design System */
        success:
          "border-transparent bg-[#16A34A] text-white shadow hover:bg-[#16A34A]/90",
        warning:
          "border-transparent bg-[#F97316] text-white shadow hover:bg-[#F97316]/90",
        info:
          "border-transparent bg-[#2563EB] text-white shadow hover:bg-[#2563EB]/90",
        /* Variantes suaves (outline style) */
        "success-outline":
          "border-[#16A34A]/30 bg-[#16A34A]/10 text-[#16A34A]",
        "warning-outline":
          "border-[#F97316]/30 bg-[#F97316]/10 text-[#F97316]",
        "error-outline":
          "border-[#EF4444]/30 bg-[#EF4444]/10 text-[#EF4444]",
        "info-outline":
          "border-[#2563EB]/30 bg-[#2563EB]/10 text-[#2563EB]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
